import { WidgetRegistry } from "@Widgets/types";
import { DevMenu } from "../Components/DevMenu/DevMenu";

const devToolsWidgetRegistry: Pick<WidgetRegistry, "DevTools.DevMenu"> = {
  "DevTools.DevMenu": {
    Component: DevMenu,
  },
};

export default devToolsWidgetRegistry;
